import { Envs } from '../../envs.js';

const getAppHost = () => {
  var _a;
  return (_a = Envs.APP_URL) !== null && _a !== void 0 ? _a : 'http://localhost:3008';
};
const getSiteHost = () => {
  var _a;
  return (_a = Envs.SITE_URL) !== null && _a !== void 0 ? _a : 'http://localhost:3000';
};
const getPayHost = () => {
  var _a;
  return (_a = Envs.PAY_URL) !== null && _a !== void 0 ? _a : 'http://localhost:3002';
};
const getAppUrl = path => {
  return `${getAppHost()}${path}`;
};
const getSiteUrl = path => {
  return `${getSiteHost()}${path}`;
};
const getGroupUrl = groupId => {
  return getSiteUrl(groupId ? `/g/${groupId}` : '/');
};
const getPayUrl = groupId => {
  return `${getPayHost()}${groupId}`;
};

export { getAppHost, getAppUrl, getGroupUrl, getPayHost, getPayUrl, getSiteHost, getSiteUrl };
